import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import DashboardV2Mixin from "@/mixins/DashboardV2Mixin.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import CustomerInsightsFilters from "@/components/customer_insights/CustomerInsightsFilters.vue";
import CurrencyFilter from "@/components/new-filters/CurrencyFilter.vue";
import { EVENTS, APP_PERIOD_DROPDOWN_ELEMENTS } from "@/utils/constants";
import NavigationTabs from "@/components/NavigationTabs.vue";
import PerformancePeriodTable from "@/components/customer_insights/PerformancePeriodTable.vue";
import PeriodControllers from "@/components/PeriodControllers.vue";
import FlexColumn from "@/components/FlexColumn.vue";
import LTVPeriodController from "@/components/LTVPeriodController.vue";
import LTVPerAsinController from "@/components/LTVPerAsinController.vue";
import { DATE_RANGES_FROM_SELECTOR, DATE_PICKER_COMPARE_TITLES, getDatePickerRangeCompare, getDatePickerUIObjectFromDateRange, momentWeekType } from "@/utils/datepicker";
import LTVPeriodTable from "@/components/customer_insights/LTVPeriodTable.vue";
import LTVPerAsinTable from "@/components/customer_insights/LTVPerAsinTable.vue";
export default {
  name: "CustomerInsightsPage",
  components: {
    CustomerInsightsFilters,
    CurrencyFilter,
    NavigationTabs,
    PerformancePeriodTable,
    PeriodControllers,
    FlexColumn,
    LTVPeriodTable,
    LTVPeriodController,
    LTVPerAsinTable,
    LTVPerAsinController
  },
  mixins: [DashboardV2Mixin, LiteTableMixin],
  data() {
    return {
      sellers: [],
      marketplaces: [],
      periodTableLoading: true,
      mediatorRefreshers: {
        PERIOD_TABLE: this.refreshPeriodTable
        //PRODUCT_TABLE: this.refreshProductTable,
      },
      DATE_RANGES_FROM_SELECTOR
    };
  },
  computed: {
    ...mapState({
      currencies: state => state.customer_insights.currencies,
      sellers_filter: state => state.customer_insights.sellers_filter,
      marketplaces_filter: state => state.customer_insights.marketplaces_filter,
      tabs: state => state.customer_insights.tabs,
      currentTabValue: state => state.customer_insights.currentTabValue,
      currentPeriod: state => state.customer_insights.currentPeriod,
      periodSelectorOptions: state => state.customer_insights.periodSelectorOptions,
      productTable: state => state.customer_insights.product_table,
      productTableGroupBy: state => state.customer_insights.product_table.group_by_text,
      floatingTableState: state => state.customer_insights.product_table.state,
      isOmnyUser: state => state.auth.isOmnyUser,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      ltvSelectorOptions: state => state.customer_insights.ltvSelectorOptions,
      ltvOffsetOptions: state => state.customer_insights.ltvOffsetOptions
    }),
    ...mapGetters(["customerInsightsGetTab", "customerInsightsGetPeriodCategory", "customerInsightsGetPeriod", "customerInsightsGetLTV", "customerInsightsGetLTVOffset", "customerInsightsGetPeriodOptions"]),
    currentSellerIds() {
      return this.sellers_filter.filterValues;
    },
    currentMarketplaceIds() {
      return this.marketplaces_filter.filterValues;
    },
    computedTabs() {
      return this.isOmnyAdmin || this.isOmnyUser ? [...this.tabs, {
        separator: true
      }, {
        text: "Cohorts",
        value: "ltv",
        activeBg: "#F3EEFF",
        activeColor: "#423994",
        feature: 'ltvtabfeature',
        event: "customerInsightsLTVTabOpened"
      }, {
        text: "LTV per asin",
        value: "ltv_per_asin",
        activeBg: "#F3EEFF",
        activeColor: "#423994",
        feature: 'ltvperasintabfeature',
        event: "customerInsightsLTVPerAsinTabOpened"
      }] : this.tabs;
    },
    tab: {
      async set(value) {
        this.$store.dispatch("customerInsightsSetTab", {
          tabIndex: value,
          tabValue: this.computedTabs[value].value
        });
        window.$bus.trigger(EVENTS.REFRESH_CUSTOMER_INSIGHTS);
      },
      get() {
        return this.customerInsightsGetTab();
      }
    },
    periodGroupBy() {
      return this.getPeriodGroupFromCurrentPeriod(this.currentPeriod, this.period);
    },
    periodCategory: {
      set(value) {
        this.applyPeriodCategoryForDatePicker(this.datePickerDate, value);
        this.$store.dispatch("customerInsightsSetPeriodCategory", value);
      },
      get() {
        return this.customerInsightsGetPeriodCategory();
      }
    },
    period: {
      set(value) {
        this.$store.dispatch("customerInsightsSetPeriod", value);
        this.$store.dispatch("customerInsightsSetGranularity", APP_PERIOD_DROPDOWN_ELEMENTS[value.toUpperCase()].endOf.toUpperCase());
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
        this.refreshMediator(["PERIOD_TABLE"]);
      },
      get() {
        return this.customerInsightsGetPeriod();
      }
    },
    ltv: {
      set(value) {
        this.$store.dispatch("customerInsightsSetLTV", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      },
      get() {
        return this.customerInsightsGetLTV();
      }
    },
    ltvOffset: {
      set(value) {
        this.$store.dispatch("customerInsightsSetLTVOffset", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      },
      get() {
        return this.customerInsightsGetLTVOffset();
      }
    },
    periodOptions() {
      return this.customerInsightsGetPeriodOptions;
    },
    computedPeriodSelectorOptions() {
      return this.currentTabValue === "dashboard" ? this.periodSelectorOptions.slice(0, 1) : this.periodSelectorOptions;
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    }
  },
  beforeUnmount() {
    window.$bus.off(EVENTS.REFRESH_CUSTOMER_INSIGHTS, () => this.refreshAllKpis());
  },
  async mounted() {
    this.datePickerCommitterFunction = this.customerInsightsSetProductTablePeriod;
    this.$store.dispatch("customerInsightsSetDefaultCurrency");
    window.$bus.on(EVENTS.REFRESH_CUSTOMER_INSIGHTS, () => this.refreshAllKpis());
    await this.initializeSellersFilter(this.customerInsightsSellersFilterSet);
    this.sellers_filter.selectWhenNoSelected(this.sellers_filter.filterItems[0], "id");
    this.sellers_filter.selectOneWhenMultipleSelected(this.sellers_filter.filterItems[0], "id");
    this.sellers_filter.apply();
    await this.refreshCustomerInsightsSellersSubFilters(true);
    window.$bus.on(EVENTS.REFRESH_CUSTOMER_INSIGHTS_SELLERS_SUB_FILTERS, this.refreshCustomerInsightsSellersSubFilters);
    // Set the default date picker date
    this.applyPeriodForDatePicker(this.periodGroupBy);
    this.refreshPeriodTable();
  },
  methods: {
    ...mapMutations(["customerInsightsSellersFilterSet", "customerInsightsMarketplacesFilterSet", "customerInsightsSetPeriod", "customerInsightsSetLTV", "customerInsightsSetLTVOffset", "customerInsightsSetProductTablePeriod"]),
    ...mapActions(["customerInsightsSetPeriodCategory"]),
    handleErrorOccured() {
      this.announceNoAccounts();
    },
    async refreshCustomerInsightsSellersSubFilters(check_local_storage) {
      // Never restore the saved sales_channel selection here: the seller is auto
      // selected on mount, so a restored selection can belong to another seller.
      await this.initializeMarketplacesFilter(this.customerInsightsMarketplacesFilterSet, check_local_storage);
      this.marketplaces_filter._key = "sales_channel";
    },
    handleSetPeriodTable(date) {
      this.handleSetLiteTablePeriod(date, this.period, this.handleDateChange, this.datePickerCompareTitle(this.periodCategory));
    },
    async handleDateChange(date) {
      if (!date) {
        date = this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      }
      this.storeDatePickerDate(date);
      //await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    async refreshMediator(refresheeList) {
      const perf = [];
      perf.push(performance.now());
      //console.log("Refreshee List", refresheeList);
      refresheeList.forEach(refreshee => {
        this.mediatorRefreshers[refreshee]();
      });
      perf.push(performance.now());

      //console.log(`[perf][refreshMediator]: ${(perf[1] - perf[0]) / 1000} s`);
    },
    async refreshPeriodTable() {
      this.periodTableLoading = true;
      await this.$store.dispatch("customerInsightsFetchPeriodTableData");
      this.periodTableLoading = false;
    },
    async refreshProductTable() {
      this.productTableLoading = true;
      /*
      const groupByFetch =
        this.productTable[this.currentTabValue].data[this.productTableGroupBy]
          ?.fetch;
         if (groupByFetch) await this.$store.dispatch(groupByFetch);
      */
      this.productTableLoading = false;
    },
    refreshAllKpis() {
      //this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
      this.refreshMediator(["PERIOD_TABLE"]);
    },
    handleProductTableSort({
      sort,
      direction
    }) {
      this.$store.dispatch("customerInsightsSetProductTableSort", {
        sort,
        direction
      });
      //this.refreshMediator(["PRODUCT_TABLE"]);
    },
    handleApplyForCurrencyChange() {
      if (this.currencies.isModified) {
        this.currencies.apply();
        this.$store.dispatch("currencyConfigSetCurrency", this.currencies.filterValues[0]);
        this.refreshAllKpis();
      }
    },
    async getFilterValuesForSellersFilter() {
      let sellers = await this.getOmnyAccountSellers();
      return sellers;
    }
  }
};